import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss'
})
export class LoadingComponent {
  /**
   * Texto sob o spinner.
   *
   * <p>Opcional, com o texto de sempre como padrão — as telas que já usavam o
   * componente continuam iguais. Vale informar quando a espera passa de um
   * instante: numa operação de vários segundos, "Aguarde..." não diz se o
   * sistema está trabalhando ou travado.</p>
   */
  @Input() mensagem = 'Aguarde...';
}
